<template>
  <Container class="mb-12 flex justify-center gap-8">
    <div>
      <button
        :disabled="!(page > 1)"
        class="flex h-16 w-16 items-center justify-center rounded-full border border-gray-200 text-gray-200 duration-100 hover:border-white hover:text-white disabled:cursor-not-allowed disabled:border-gray-300 disabled:text-gray-300"
        @click="handlePrevPage">
        <span class="sr-only">Previous page</span>
        <IconChevronDown class="h-6 w-6 rotate-90" />
      </button>
    </div>
    <div>
      <button
        :disabled="!(totalItems > page * itemsToShow)"
        class="flex h-16 w-16 items-center justify-center rounded-full border border-gray-200 text-gray-200 duration-100 hover:border-white hover:text-white disabled:cursor-not-allowed disabled:border-gray-300 disabled:text-gray-300"
        @click="handleNextPage">
        <span class="sr-only">Next page</span>
        <IconChevronDown class="h-6 w-6 -rotate-90" />
      </button>
    </div>
  </Container>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  type BlogPagination = {
    totalItems: number
    itemsToShow: number
    queryParam: string
  }

  const props = defineProps<BlogPagination>()

  const route = useRoute()
  const router = useRouter()

  const page = ref(route.query[props.queryParam] ? Number(route.query[props.queryParam]) : 1)

  // watch route.query.page and set it to page.value
  watch(
    () => route.query[props.queryParam],
    () => {
      page.value = route.query[props.queryParam] ? Number(route.query[props.queryParam]) : 1
    }
  )

  function handleNextPage() {
    router.push({
      query: {
        ...route.query,
        [props.queryParam]: page.value + 1
      }
    })
  }

  function handlePrevPage() {
    router.push({
      query: {
        ...route.query,
        [props.queryParam]: page.value - 1
      }
    })
  }
</script>
